import clsx from 'clsx';
import { sidebarStyle } from '../../sidebar.style';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';

export const MenuWrapper = ({ 
	title,
	children
}: {
	title?: string | null;
	children: React.ReactNode;
}) => {
	const view = useAppearanceStore(state => state.view);

	return (
		<div className={clsx('side-menu', { [sidebarStyle.sideMenu]: view === ViewEnum.mars })}>
			{title && <div className={clsx('side-menu__title', { [sidebarStyle.sideMenuTitle]: view === ViewEnum.mars })}>{title}</div>}
			{children}
		</div>
	);
};